import { render, staticRenderFns } from "./share.vue?vue&type=template&id=f2cec51e&scoped=true"
import script from "./share.vue?vue&type=script&lang=js"
export * from "./share.vue?vue&type=script&lang=js"
import style0 from "./share.vue?vue&type=style&index=0&id=f2cec51e&prod&lang=scss&scoped=true"
import style1 from "./share.vue?vue&type=style&index=1&id=f2cec51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cec51e",
  null
  
)

export default component.exports